export default "__VITE_ASSET__f1e48c25__"